'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssComponent = require('react-css-component');

var _colors = require('../styles/colors');

var colors = _interopRequireWildcard(_colors);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var css = '\n.graphic-time-remaining {\n  height: 5px;\n}\n.graphic-time-elapsed {\n  float: right;\n  height: 5px;\n  background-color: #ccc;\n}\n';

var LineupCardTimeRemaining = function LineupCardTimeRemaining(props) {
    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(_reactCssComponent.UniversalStyle, { css: css }),
        _react2.default.createElement(
            'div',
            { className: 'graphic-time-remaining', style: { backgroundColor: colors[props.color] } },
            _react2.default.createElement('div', { className: 'graphic-time-elapsed', style: { width: props.lineup.time_elapsed + '%' } })
        )
    );
};

exports.default = LineupCardTimeRemaining;


//////////////////
// WEBPACK FOOTER
// ../component-library/build/lineups/LineupCardTimeRemaining.js
// module id = 387
// module chunks = 0